export const offersData: any[] = [
    { value: 1, offerName: "All Offers" },
    { value: 2, offerName: "Up to 50% off" },
    { value: 3, offerName: "weekend offers" },
    { value: 4, offerName: "Family Deals" },
    { value: 5, offerName: "Christmas Special" },
    { value: 6, offerName: "20% off" },
    { value: 7, offerName: "Buy one get one free" },
];